import React, { useState } from 'react';
import Modal from '@hubins/components/Modal/Modal';
import Heading from '@hubins/components/Heading/Heading';
import Input from '@hubins/components/Input';
import { Column, Columns } from 'components/Columns';
import __ from 'localisation';
import Button, { ButtonWrap } from '@hubins/components/Button';
import { useMiddleman } from '@hubins/middleman';
import ErrorMessage from 'components/ErrorMessage';
import Dropdown from '@hubins/components/Dropdown';
import { crsOptions } from 'helpers/crs';
import { fatcaOptions } from 'helpers/fatca';
import CountriesDropdown from '@hubins/components/CountriesDropdown/CountriesDropdown';

const EditProfileModal = ({ profile, open, setOpen, setProfile, isCompany }) => {

  const [address, setAddress] = useState(profile?.address || '');
  const [city, setCity] = useState(profile?.city || '');
  const [postalCode, setPostalCode] = useState(profile?.postal_code || '');
  const [country, setCountry] = useState(profile?.country || '');
  const [phoneNumber, setPhoneNumber] = useState(profile?.phone_number || '');
  const [email, setEmail] = useState(profile?.email || '');
  const [crs, setCrs] = useState(profile?.crs || '');
  const [fatca, setFatca] = useState(profile?.fatca || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const middleman = useMiddleman();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await middleman.post(`/ql/crm/profile/update/${profile.uuid}`, {
        address,
        city,
        postal_code: postalCode,
        country,
        phone_number: phoneNumber,
        email,
        ...(isCompany ? {
          crs,
          fatca,
        } : {}),
      });
      setOpen(false);
      setProfile((prevProfile) => ({
        ...prevProfile,
        address,
        city,
        postal_code: postalCode,
        country,
        phone_number: phoneNumber,
        email,
        ...(isCompany ? {
          crs,
          fatca,
        } : {}),
      }));
    } catch (error) {
      setError(error.message);
    }
    setLoading(false);
  }

  return (
    <Modal open={open} callback={setOpen}>
      <form onSubmit={handleSubmit}>
        <Columns>
          <Column s="12">
            <Heading size="4">{__('edit_profile')}</Heading>
          </Column>
          <Column m="6">
            <Input label={__('address')} value={address} callback={setAddress} />
          </Column>
          <Column m="6">
            <Input label={__('city')} value={city} callback={setCity} />
          </Column>
          <Column m="6">
            <Input label={__('postal_code')} value={postalCode} callback={setPostalCode} />
          </Column>
          <Column m="6">
            <CountriesDropdown label={__('country')} value={country} callback={setCountry} placeholder={__('select_country')} />
          </Column>
          <Column m="6">
            <Input label={__('phone_number')} value={phoneNumber} callback={setPhoneNumber} />
          </Column>
          <Column m="6">
            <Input label={__('email')} value={email} callback={setEmail} />
          </Column>
          {isCompany && (
            <>
              <Column m="6">
                <Dropdown label={__('crs')} options={crsOptions} value={crs} callback={setCrs} />
              </Column>
              <Column m="6">
                <Dropdown label={__('fatca')} options={fatcaOptions} value={fatca} callback={setFatca} />
              </Column>
            </>
          )}
          <Column s="12">
            <ButtonWrap>
              <Button type="submit" className='cta' disabled={loading} loading={loading}>
                {__('save')}
              </Button>
              <Button type="button"  onClick={() => setOpen(false)}>
                {__('cancel')}
              </Button>
            </ButtonWrap>
            <ErrorMessage text={error} showError={!!error} />
          </Column>
        </Columns>
      </form>
    </Modal>
  );
};

export default EditProfileModal;
